import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { ListLosses } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/ListLosses";
import { ResourceCards } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/ResourceCards";
import { NormalText } from "@/components/text/NormalText";
import { UserNoDates } from "@/types/types";

export function Welcome({
  title,
  user,
  numberOfModels,
  numberOfMixedModels,
  onContinue,
  onStay,
}: {
  title: string;
  user: UserNoDates;
  numberOfModels: number;
  numberOfMixedModels: number;
  onContinue: () => void;
  onStay: () => void;
}) {
  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>

      <ResourceCards
        user={user}
        numberOfModels={numberOfModels}
        numberOfMixedModels={numberOfMixedModels}
      />

      <ListLosses />

      <CancelButtons
        positiveText="Keep subscription"
        negativeText="Continue"
        onPositive={onStay}
        onNegative={onContinue}
      />
    </div>
  );
}
